import { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { isDebug } from '../config';

const withErrorHandler = (ComposedComponent) => {
  class WithErrorHandler extends Component {
    constructor() {
      super();

      this.state = {
        hasError: false,
      };
    }

    handleError = ({ description, message, errorData }) => {
      this.setState({
        hasError: true,
      });

      const data = {
        description,
        message,
        errorData,
        type: 'error',
        userAgent: this.state.userAgent,
        clientId: this.state.clientId,
      };

      toast.error(message || errorData.message || errorData);

      if (isDebug) {
        console.log('err', data);
      }

      /* 
     axios
        .post(`/api/log`, data)
        .then((res) => {})
        .catch((e) => {
          console.error('Failed to send log message', e);
        });
        */
    };

    handleWarning = (message) => {
      toast.warn(message);
    };

    render() {
      if (this.state.hasError) {
        const { error, errorInfo } = this.state;
        return (
          <>
            <ComposedComponent
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...this.props}
              error={error}
              errorInfo={errorInfo}
              handleError={this.handleError}
              handleWarning={this.handleWarning}
            />

            <ToastContainer position={toast.POSITION.BOTTOM_LEFT} />
          </>
        );
      }

      return (
        <ComposedComponent
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          handleError={this.handleError}
          handleWarning={this.handleWarning}
        />
      );
    }
  }

  WithErrorHandler.displayName = `withErrorHandler(${Component.displayName})`;

  return WithErrorHandler;
};

export default withErrorHandler;
